module.exports = __webpack_public_path__ + "img/候选人.9d013669.png";